import * as types from './mutation_types'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      updated: null,
      violations: null
    })
  },

  [types.SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.SET_UPDATED] (state, updated) {
    Object.assign(state, { updated })
  },

  [types.SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { violations })
  }
}
